import { render } from "./iconPhone.vue?vue&type=template&id=baba30b2"
import script from "./iconPhone.vue?vue&type=script&lang=js"
export * from "./iconPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__